import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom'; // Import Link

import { FaApple, FaAndroid, FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram, FaYoutube, FaWhatsapp } from 'react-icons/fa';

const footerData = {
  company: ['About CRISHI', 'Contact us', 'Help & faq', 'Careers', 'Sitemap'],
  // Changed "crops" to "commodity" to match the heading
  commodity: [
    'Wheat', 'Rice', 'Sugar', 'Cotton', 'Maize', 'Pulses', 
    'Spices', 'Vegetables', 'Oilseeds', 
  ],
  region: ['India', 'Argentina', 'Australia', 'Bangladesh', 'Germany', 'Nepal', 'Singapore', 'Turkey', 'United States', 'Vietnam'],
  features: ['Prices', 'Insights', 'Tenders', 'Data & Statistics', 'Reports', 'Info graphics', 'Data licensing', 'Content partnership']
};

const Footer = () => {
  // Split the commodity array into two equal(ish) columns
  const midPoint = Math.ceil(footerData.commodity.length / 2);
  const commodityCol1 = footerData.commodity.slice(0, midPoint);
  const commodityCol2 = footerData.commodity.slice(midPoint);

  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-links-grid">
          
          <div className="footer-column">
            <h3>Company</h3>
            <ul>{footerData.company.map((link, i) => <li key={i}><Link to="/">{link}</Link></li>)}</ul>
          </div>

          {/* --- THIS IS THE CORRECTED STRUCTURE --- */}
          <div className="footer-column commodity-column">
            <h3>Commodity</h3>
            <div className="commodity-subgrid">
              <ul>
                {commodityCol1.map((link, i) => <li key={i}><Link to="/">{link}</Link></li>)}
              </ul>
              <ul>
                {commodityCol2.map((link, i) => <li key={i}><Link to="/">{link}</Link></li>)}
              </ul>
            </div>
          </div>

          <div className="footer-column">
            <h3>Region</h3>
            <ul>{footerData.region.map((link, i) => <li key={i}><Link to="/">{link}</Link></li>)}</ul>
          </div>

          <div className="footer-column">
            <h3>Our Features</h3>
            <ul>{footerData.features.map((link, i) => <li key={i}><Link to="/">{link}</Link></li>)}</ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="app-download">
            <span>Download App</span>
            <a href="/" className="app-icon"><FaApple /></a>
            <a href="/" className="app-icon"><FaAndroid /></a>
          </div>
          <div className="social-media">
            <a href="/" className="social-icon"><FaFacebookF /></a>
            <a href="/" className="social-icon"><FaTwitter /></a>
            <a href="/" className="social-icon"><FaLinkedinIn /></a>
            <a href="/" className="social-icon"><FaInstagram /></a>
            <a href="/" className="social-icon"><FaYoutube /></a>
            <a href="/" className="social-icon"><FaWhatsapp /></a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;